import type { TFunction } from 'i18next';
import type { AssessmentResultItemDataFragment } from '../../../Trainee/TraineeReports.api';
import type { CognitiveFitness } from '../../model';

// eslint-disable-next-line import/prefer-default-export
export const buildDefaultCognitivePlaceholder = (
    t: TFunction,
    item: AssessmentResultItemDataFragment
): CognitiveFitness | null => {
    const mi = item.moduleInstance;
    if (!mi?.moduleDefinitionIdentifier) {
        return null;
    }

    return {
        name: mi.name ?? '',
        moduleDefinitionIdentifier: mi.moduleDefinitionIdentifier ?? '',
        description: mi.description ?? '',
        result: [
            { label: t('traineeReports:performance.cognitiveFitness.scoreLabel'), value: t('traineeReports:na') },
            {
                label: t('traineeReports:performance.cognitiveFitness.avgResponseTimeMs'),
                value: t('traineeReports:na'),
            },
        ],
    };
};
